<template>
  <!-- 查询表单 -->
  <el-form
    v-if="formList.length"
    ref="formFields"
    :model="searchObj"
    size="small"
    class="fan-search margin-bottom-8"
    :inline="true"
    @submit.native.prevent
  >
    <!-- 查询条件 -->
    <template v-for="(query, keys) in searchList">
      <div
        :key="`q${keys}`"
        class="fan-search-col"
      >
        <el-form-item
          :label="query.label ? query.label : ''"
          :prop="query.name"
          :class="{'no-label': Boolean(!query.label)}"
          :rules="query.rules"
        >
          <template v-if="query.slot">
            <slot :name="query.slot" />
          </template>
          <template v-else>
            <field-item
              :value.sync="searchObj[query.name]"
              :query="query"
              :searchObj="searchObj"
              v-bind="query.attrs"
              v-on="query.events"
              @keyup.enter="handleSearchClick"
              @setFormFields="setFormFields"
            />
          </template>
        </el-form-item>
      </div>
    </template>

    <div class="fan-search-col fan-search-right">
      <el-button
        type="primary"
        :size="formSize"
        :loading="loading"
        @click="handleSearchClick"
      >
        查询
      </el-button>
      <!-- 兼容批量查询按钮存放 -->
      <slot name="batch-search-btn" />
      <el-button
        :size="formSize"
        :loading="loading"
        @click="handleReset"
      >
        重置
      </el-button>
    </div>
  </el-form>
</template>

<script>
import FieldItem from './fieldItem';
import { isObject, cloneDeep } from 'lodash';

export default {
  name: 'SearchMenu',
  components: {
    FieldItem,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    // 查询条件列表search-list
    formList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 查询参数值
    searchValue: {
      type: Object,
      default: () => {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    searchObj: {
      deep: true,
      handler(val) {
        const objValue = cloneDeep(this.getSearchObj(val));
        this.$emit('update:searchValue', { ...this.searchValue, ...objValue });
      },
      immediate: true,
    },
  },
  data() {
    return {
      searchObj: {},
      defualtValueMap: Object.freeze(new Map()),
    };
  },
  computed: {
    searchList() {
      return this.formList;
    },
  },
  mounted() {
    // 初始化默认值项
    this.init();
  },
  methods: {
    init() {
      const tempSearchObj = {};
      this.formList.forEach((t) => {
        if (t.name) {
          if (typeof t.value === 'undefined') {
            tempSearchObj[t.name] = '';
          } else {
            tempSearchObj[t.name] = t.value;
            this.defualtValueMap.set(t.name, t.value);
          }
          this.initOptionCallBack(t);
        }
        // 设置保存下拉选择器默认值
        if (t.queryItem && isObject(t.queryItem) && t.queryItem.key) {
          tempSearchObj[t.queryItem.key] = t.queryItem.value;
          this.defualtValueMap.set(t.queryItem.key, t.queryItem.value);
        }
      });
      this.searchObj = { ...this.searchObj, ...tempSearchObj };
    },
    initOptionCallBack(item) {
      const { optionsCallBack } = item;
      if (typeof optionsCallBack === 'function') {
        const options = optionsCallBack();
        item.options = options || [];
      }
    },
    // 查询
    handleSearchClick() {
      const searchObj = cloneDeep(this.getSearchObj(this.searchObj));
      this.$emit('search', searchObj);
    },
    getSearchObj(obj = {}) {
      const searchObj = cloneDeep(obj);
      // 删除 时间选择器 多余字段
      this.formList.forEach((componentConfig) => {
        if (componentConfig && componentConfig.component === 'search-date-picker') {
          delete searchObj[componentConfig.name];
        }
      });
      return searchObj;
    },
    // 重置搜索条件
    resetField() {
      // this.$refs.formFields.resetFields();
      Object.keys(this.searchObj).forEach((key) => {
        if (typeof this.defualtValueMap.get(key) !== 'undefined') {
          this.searchObj[key] = this.defualtValueMap.get(key);
        } else if (this.isArray(this.searchObj[key])) {
          this.searchObj[key] = [];
        } else {
          this.searchObj[key] = '';
        }
      });
    },
    isArray(obj) {
      return (
        Object.prototype.toString
          .call(obj)
          .replace(/^\[object (.+)\]$/, '$1')
          .toLowerCase() === 'array'
      );
    },
    // 重置并响应父组件
    handleReset() {
      this.resetField();
      this.$emit('reset');
    },
    // 为了自定义组件参数整合
    setFormFields(params = {}, componentConfig) {
      // 时间选择, 作用于监听变化
      const dateRange = {};
      if (componentConfig && componentConfig.component === 'search-date-picker') {
        dateRange[componentConfig.name] = params;
      }
      const obj = { ...this.searchObj, ...params, ...dateRange };
      const searchObj = cloneDeep(this.getSearchObj(obj));
      this.searchObj = cloneDeep(obj);
      this.$emit('setQuery', searchObj);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form-item {
    margin-bottom: 0 !important;
  }
  .el-form-item__label {
    padding-right: 8px;
    color: #2a304d;
    font-size: inherit;
    white-space: nowrap;
  }
  .no-label {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}

.fan-search-col {
  margin-right: 22px;
  &:last-child {
    margin-right: 0;
  }
}
</style>
